// Copyright (c) Bentley Systems
import { SvgCloseSmall } from "@itwin/itwinui-icons-react";
import {
  Button,
  ButtonGroup,
  ColorBuilder,
  ColorInputPanel,
  ColorPicker,
  ColorSwatch,
  ColorValue,
  IconButton,
  Popover,
} from "@itwin/itwinui-react";
import * as React from "react";

export type ColorPickerInterFace = {
  label: string | undefined;
  selectedValue: string | undefined;
  required: boolean;
  onChange(colorHexString: string | null): void;
  hideNoneButton?: boolean;
};

export const EfColorPicker = (props: ColorPickerInterFace) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedColor, setSelectedColor] = React.useState<
    ColorValue | undefined
  >(
    props.selectedValue !== undefined && props.selectedValue !== null
      ? ColorValue.create(props.selectedValue)
      : undefined,
  );

  const onColorChanged = (color: ColorValue | undefined) => {
    setSelectedColor(color);
    if (color !== undefined) {
      const colorHexString = getDisplayString(color);
      props.onChange(colorHexString);
    } else {
      props.onChange(null);
    }
  };

  const getDisplayString = (color = selectedColor) => {
    return color !== undefined ? color.toHexString().toUpperCase() : null;
  };

  return (
    <>
      <div>
        {props.label !== undefined && (
          <div className="becs-input-grid">
            <div
              className={
                props.required
                  ? "becs-input-label required"
                  : "becs-input-label"
              }
            >
              {props.label}
            </div>
          </div>
        )}
        <ButtonGroup>
          <Popover
            content={
              <ColorPicker
                selectedColor={selectedColor}
                onChangeComplete={onColorChanged}
              >
                <ColorBuilder />
                <ColorInputPanel defaultColorFormat="hex" />
                {!props.hideNoneButton && (
                  <Button
                    size="small"
                    onClick={() => {
                      onColorChanged(undefined);
                      setIsOpen((open) => !open);
                    }}
                    startIcon={<SvgCloseSmall />}
                  >
                    None
                  </Button>
                )}
              </ColorPicker>
            }
            visible={isOpen}
            placement="bottom-start"
          >
            <IconButton
              onClick={() => setIsOpen((open) => !open)}
              label="Color"
            >
              <ColorSwatch
                style={{ pointerEvents: "none", margin: 0 }}
                color={selectedColor ?? "white"}
              />
            </IconButton>
          </Popover>
          <Button onClick={() => setIsOpen((open) => !open)}>
            <div style={{ width: 215 }}>
              {getDisplayString() ?? "No color selected."}
            </div>
          </Button>
        </ButtonGroup>
      </div>
    </>
  );
};
